import React from 'react'
import styles from './MainApp.organisms.Dashboard.Card.module.scss';

const Card = ({children}) => {
    return <div className={styles["dashboard-card-container"]}>
        {children}
    </div>
};

export default Card;